<template>
    <div class="footer-body">
        <div class="footer-menu-list">
            <div class="menu" 
                v-for="(n, index) in menuList" 
                :key="index"
                @click="linkTo(index)"
                :class="{selected: index === menuSelected}"
            >
                <i class="el-icon-arrow-right"></i>{{ n.name }}
            </div>
        </div>
        <div class="icon-area">
            <span >
                <img :src="icon.facebook[iconSleceted[0]]" @click="selectedIcon(0)">
            </span>
            <span>
                <img :src="icon.twitter[iconSleceted[1]]" @click="selectedIcon(1)">
            </span>
            <span>
                <img :src="icon.wechat[iconSleceted[2]]" @click="selectedIcon(2)">
            </span>
        </div>
        <div class="company-msg">
            Copyright © 2020-2021  KaitekiTV TECH CO., LIMITED
        </div>
        <div class="qrcode-area" v-show="qrcodeShowItem !== null" @click.stop="hideQrcode()">
            <img :src="qrcodeShowItem" alt="微信二维码" @click.stop>
        </div>
    </div>
</template>
<script>
import icon from '../../../images/footer.js'
import wechatAdd from '../../../images/wechat-add.png'
export default {
    data () {
        return {
            menuSelected: null,
            icon,
            iconSleceted: [
                0,0,0
            ],
            iconLinks: [
                {
                    type: 'url',
                    url: 'https://www.facebook.com/kaitekitv'
                },
                {
                    type: 'url',
                    url: 'https://twitter.com/KAITEKITV1'
                },
                {
                    type: 'qrcode',
                    imageUrl: wechatAdd
                },
            ],
            qrcodeShowItem: null,
            menuList: [
                {
                    name: 'アプリについて',
                    to: '/aboutApp'
                },
                {
                    name: '個人情報保護について',
                    to: '/protection'
                },
                {
                    name: 'おすすめ利用端末のご購入',
                    to: '/device'
                },
                {
                    name: 'よくあるご質問',
                    to: '/faq'
                },
                {
                    name: 'お問い合わせ',
                    to: '/contectUs'
                }
            ]
        }
    },
    methods: {
        linkTo (index) {
            this.menuSelected = index
            setTimeout(() => {
                this.$router.push(this.menuList[index].to)
            }, 200)
        },
        selectedIcon (index) {
            this.iconSleceted[index] = 1
            setTimeout(() => {
                this.iconSleceted[index] = 0
            },200)
            if (this.iconLinks[index].type === 'url') {
                window.open(this.iconLinks[index].url)
            } else if (this.iconLinks[index].type === 'qrcode') {
                console.log('qrcode')
                this.qrcodeShowItem = this.iconLinks[index].imageUrl
            }
        },
        hideQrcode () {
            this.qrcodeShowItem = null
        }
        
    }
}
</script>
<style scoped>
.footer-body {
    background: #040404;
    color: #fff;
    width: 100%;
    box-sizing: border-box;
    padding-top: 50px;
    background-image: url(../../../images/footer-bg.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position-y: 0;
    padding-bottom: 60px;
    position: relative;
    z-index: 1;
}
.footer-menu-list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 20px;
}
.menu {
    transition: all .2s;
    margin: 15px 0;
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #FFFFFF;
}
.menu.selected {
    color: #FDB819;
    transform: translateX(10px);
}
.company-msg {
    font-size: 14px;
    font-family: A-OTF Gothic MB101 Pro;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 11px;
    transform: translateX(-70px) scale(0.5,0.65);
}
.icon-area img {
    display: inline-block;
    width: 24px;
}
.icon-area span {
    margin-right: 10px;
}
.icon-area {
    box-sizing: border-box;
    padding-left: 20px;
    margin-bottom: 10px;
}
.qrcode-area {
    position: fixed;
    width: 100%;
    height:100%;
    top:0;
    left: 0;
    background: rgba(0,0,0,.5);
}
.qrcode-area img{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 216px;
    height: 216px;
    z-index: 99999;
}
</style>